﻿import React from "react";
import { observer } from "mobx-react";
import { injectFromApp } from "../../inject";
import type { INewsMenuStore } from "./NewsMenuStore";
import { RichToolTipComponent } from "../../rich-tooltip/RichToolTipComponent";
import { NewsItemComponent } from "./NewsItemComponent";
import { fireAndForget } from "../../../util/async/FireAndForget";

interface INewsMenuComponentProps {
    newsMenuStore?: INewsMenuStore;
}

@injectFromApp<INewsMenuComponentProps>((stores) => ({
    newsMenuStore: stores.newsMenuStore,
}))

@observer
export class NewsMenuComponent extends React.Component<INewsMenuComponentProps> {

    componentDidMount() {
        const { newsMenuStore } = this.props;
        fireAndForget(newsMenuStore!.loadNewsItems());
    }

    render() {
        const { newsMenuStore } = this.props;
        const { newsItems, mostRecentNewsItemAlreadySeen } = newsMenuStore!;

        if (!newsItems || newsItems.length == 0) return null;

        const hasMaintenance = !!newsItems.find(s => s.maintenance);

        return (
            <RichToolTipComponent
                toolTipPosition={ "left" }
                toolTipResource={ "News" }
                className={ "selected" + (hasMaintenance ? " maintenance" : "") }
                id={ "news-menu" }
                onMouseOver={ () => newsMenuStore!.setLastShownNewsUpdateTimeInCookie() }>

                <div id={ "nr-of-news" } className={ (!mostRecentNewsItemAlreadySeen ? "active" : "") }>{ newsItems.length }</div>
                <div id={ "news-items" }>
                    { newsItems.map((n) => <NewsItemComponent newsItem={ n } key={ n.id }/>) }
                </div>
                
            </RichToolTipComponent>
        );
    }
}
